<template>
  <MessageBox v-if="visible" type="error" :message="message"/>
</template>

<script>
  import MessageBox from "../atoms/MessageBox";
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "molecule",
    name: "ErrorMessage",
    props: {
      "message": String
    },
    computed: {
      visible () {
        return this.message !== null && this.message !== ""
      }
    },
    components: {
      MessageBox,
    }
  }
</script>

<style scoped lang="sass">

</style>